import React from 'react';
import { Outlet } from 'react-router-dom';
import SubNavigator from '../../components/SubNavigator';
import { PageContainer, SideNavigation, SectionContainer, SectionHeading, MainContent } from '../../components/SubNavigator';

const sections = [
  {
    heading: '예매대행',
    links: [
      { path: '/Tiketting/UserOptions', label: '예매대행 옵션등록' },
      { path: '/Tiketting/AssignOrder', label: '티켓정보조회' },
      { path: '/Tiketting/PublicOrderList', label: '공개경매조회' },
      { path: '/Tiketting/bidsHistory', label: '내 입찰현황' },
     
    ],
  },
  {
    heading: '대행내역',
    links: [
      {path: '/Tiketting/OrderHistory', label: '대행내역'},
      {path: '/Tiketting/BlockingHistory', label: '블로킹내역'},
    ]
  },
  {
    heading: '가이드',
    links: [
      { path: '/Settings/MyPage', label: '이용안내' },
      { path: '/Settings/MyPage', label: '출금안내' },
      { path: '/Settings/MyPage', label: '대행자 클래스' },
    ]
  },

];

export default function Tiketting() {
  return (
    <PageContainer>
      <SideNavigation>
        {sections.map((section, index) => (
          <SectionContainer key={index}>
            <SectionHeading>{section.heading}</SectionHeading>
            <SubNavigator links={section.links} />
          </SectionContainer>
        ))}
      </SideNavigation>
      <MainContent>
        <Outlet />
      </MainContent>
    </PageContainer>
  );
}